<main class="rayalina-auth-shell rayalina-auth-shell--split">
    <aside class="auth-aside" aria-label="À propos de Rayalina">
        <div class="auth-aside__brand">
            <h2 class="auth-aside__title">Structurez ventes et encaissements dès aujourd'hui.</h2>
            <p class="auth-aside__lead">
                Créez votre espace en quelques minutes. L'essai gratuit couvre commandes, factures, paiements et clients.
            </p>
            <ul class="auth-aside__points">
                <li><i class="bx bx-gift" aria-hidden="true"></i> Essai gratuit sans carte bancaire</li>
                <li><i class="bx bx-receipt" aria-hidden="true"></i> Factures et suivi des paiements inclus</li>
                <li><i class="bx bx-up-arrow-alt" aria-hidden="true"></i> Formules évolutives en MGA</li>
            </ul>
        </div>
    </aside>
    <div class="auth-main">
        <div class="auth-main__inner">
            <div class="auth-card">
                <header class="auth-card-header">
                    <h1 class="auth-title">Créer un compte</h1>
                    <p class="auth-sub">
                        Déjà inscrit ?
                        <a routerLink="/auth/login" [queryParams]="{ returnUrl: returnUrl }">Se connecter</a>
                    </p>
                </header>
                <ng-container *ngIf="socialEnabled">
                    <app-rayalina-social-login (success)="onAuthenticated()"></app-rayalina-social-login>
                    <div class="auth-divider">
                        <span>ou par email</span>
                    </div>
                </ng-container>
                <app-rayalina-register-form
                    [returnUrl]="returnUrl"
                    (success)="onAuthenticated()"
                ></app-rayalina-register-form>
            </div>
        </div>
    </div>
</main>
